import { slipAndFallArticle } from './slipAndFall';

export const articles = [
  slipAndFallArticle,
];

export const getArticleBySlug = (slug) => articles.find(a => a.slug === slug);
